import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e344d04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "btns" }
const _hoisted_3 = {
  key: 0,
  class: "container"
}

import i18n from "@/i18n";
  import { Translation } from 'vue-i18n';
  import { useRoute } from "vue-router";
  import { onMounted, ref } from "vue";
  import ModalClose from "@/assets/icons/modalClose.vue";
  import IconArrowTop from "@/assets/icons/IconArrowTop.vue";
  import InfoButton from "@/components/InfoButton.vue";
  import MultiStep from "@/components/MultiStep.vue";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Tutorial',
  emits: ["toggle-tutorial"],
  setup(__props, { emit: __emit }) {

  const route = useRoute();
  const emitter = __emit;

  const firstConnexion = ref(false);
  const tutorials = ref([]);
  const tutorialWelcomeRef = ref();

  onMounted(() => {
    firstConnexion.value = (/true/).test(localStorage.getItem('firstConnexion') ?? '');

    //console.log(localStorage.getItem('tutorials'));
    if(localStorage.getItem('tutorials')){
      tutorials.value = JSON.parse(localStorage.getItem('tutorials')!);
      //console.log(tutorials.value);
    }
    // if(!firstConnexion.value && route.meta.tutorial){
      
    // }
  })

  const next = () => {
    setTimeout(() => {
      tutorialWelcomeRef.value.nextStep();
    }, 100);
  }

  const closeTutorial = () => {

    if(firstConnexion.value) {
      //console.log('firstClose')
      localStorage.setItem('firstConnexion', 'false');

    } else {
      //console.log(route.name)

      if( !tutorials.value.includes(String(route.name)) ) 
        tutorials.value.push(String(route.name))

      localStorage.setItem('tutorials', JSON.stringify(tutorials.value));
    }

    emitter('toggle-tutorial');
  }

  const clickOutsideText = (event) => {
    let closestDiv = event.target.closest("div");
    if(closestDiv.className == ""){
      closeTutorial();
    }
  };

  const continueTutorial = () => {
    localStorage.setItem('firstConnexion', 'false');
    firstConnexion.value = false;
  }
  

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("section", {
    class: _normalizeClass({'fullscreen': firstConnexion.value}),
    onClick: clickOutsideText
  }, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createVNode(MultiStep, {
        "steps-number": 2,
        ref_key: "tutorialWelcomeRef",
        ref: tutorialWelcomeRef
      }, {
        "1": _withCtx(() => [
          _createVNode(_unref(Translation), {
            keypath: "tutorial.welcome.text",
            tag: "h2"
          }, {
            strong: _withCtx(() => [
              _createElementVNode("strong", null, _toDisplayString(_unref(i18n).global.t('tutorial.welcome.strong')), 1)
            ]),
            _: 1
          }),
          _createVNode(IconArrowTop, {
            class: "next",
            onClick: next
          })
        ]),
        "2": _withCtx(() => [
          _createVNode(_unref(Translation), {
            keypath: "tutorial.explanation.text",
            tag: "h2"
          }, {
            strong: _withCtx(() => [
              _createElementVNode("strong", null, _toDisplayString(_unref(i18n).global.t('tutorial.explanation.strong')), 1)
            ]),
            icon: _withCtx(() => [
              _createVNode(InfoButton, { style: {"margin-top":"0"} })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              class: "btn-secondary",
              onClick: closeTutorial
            }, _toDisplayString(_unref(i18n).global.t("tutorial.close")), 1),
            _createElementVNode("button", {
              class: "btn-primary",
              onClick: continueTutorial
            }, _toDisplayString(_unref(i18n).global.t("tutorial.continue")), 1)
          ])
        ]),
        _: 1
      }, 512),
      _createVNode(ModalClose, {
        class: "close",
        onClick: closeTutorial
      })
    ], 512), [
      [_vShow, firstConnexion.value]
    ]),
    (!firstConnexion.value && _unref(route).meta.tutorial)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_unref(Translation), {
            keypath: `tutorial.${String(_unref(route).name)}.title`,
            tag: "h1"
          }, null, 8, ["keypath"]),
          _createVNode(_unref(Translation), {
            keypath: `tutorial.${String(_unref(route).name)}.text`,
            tag: "p"
          }, {
            strong: _withCtx(() => [
              _createElementVNode("strong", null, _toDisplayString(_unref(i18n).global.t(`tutorial.${String(_unref(route).name)}.strong`)), 1)
            ]),
            _: 1
          }, 8, ["keypath"]),
          _createVNode(ModalClose, {
            class: "close",
            onClick: closeTutorial
          })
        ]))
      : _createCommentVNode("", true)
  ], 2)), [
    [_directive_click_outside, closeTutorial]
  ])
}
}

})